module.exports = __webpack_public_path__ + "img/fjall2.430c4327.jpg";